import React from 'react'
import { parsePhoneNumberFromString } from 'libphonenumber-js/min'

function formatNumber(phoneNumber, countryCode) {
  try {
    const parsedNumber = parsePhoneNumberFromString(phoneNumber, countryCode)
    return parsedNumber.formatNational()
  } catch (e) {
    return phoneNumber
  }
}

/**
 * Display a phone number in the style common to the country that the number is in.
 * countryCode is a hint, but the phone number itself will take precedent if there is a mismatch.
 * @param {Object} props
 * @param {String} props.phoneNumber
 * @param {String} [props.countryCode] - two letter ISO country code like CN or US
 */
const InternationalPhoneDisplay = (props) => {
  const phoneNumber = formatNumber(props.phoneNumber, props.countryCode)
  return <React.Fragment>{phoneNumber}</React.Fragment>
}

export default InternationalPhoneDisplay
